import * as React from 'react';
import { useEffect } from 'react';

import uuid from '@/utils/uuid';

export interface ScriptProps {
  src: string;
  type?: string;
  id?: string;
  children?: string | Node;

  [key: string]: unknown;
}

const NextScript: React.FC<ScriptProps> = ({ type, src, id, children, ...rest }) => {
  useEffect(() => {
    // Done this because some scripts are cached by browser and doesn't load on route change
    const scriptId = uuid.v4(`eromScript${id ? '-' + id : ''}`);
    let scriptSrc = src;
    if (scriptSrc) {
      const url = new URL(src);
      url.searchParams.set('eromLocalVersion', uuid.v4('ver'));
      scriptSrc = url.toString();
    }
    const script = document.createElement('script');
    script.type = type ?? 'text/javascript';
    script.id = scriptId;
    if (scriptSrc) {
      script.src = scriptSrc;
    }
    if (children) {
      script.append(children);
    }
    // Apply any additional attributes
    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        script.setAttribute(key, String(value));
      }
    });
    const scriptAppendTimeout = setTimeout(() => document.head.appendChild(script), 1000);
    return () => {
      // Remove dynamically created script
      if (scriptId) {
        document.getElementById(scriptId)?.remove();
      }
      clearTimeout(scriptAppendTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default NextScript;
